/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

/**
 * Consumption cycle lifetime policy for a contract rate.
 */
export type CycleKind = typeof CycleKind[keyof typeof CycleKind];


export const CycleKind = {
  rolling: 'rolling',
  calendar: 'calendar',
} as const;
